import { defaultApi } from '@/api';
import { components } from '@/types/api';

// Get parents of an initiative
export async function getInitiativeParents({ initiativeId }: { initiativeId: number }) {
  const { data } = await defaultApi.get<components['schemas']['Initiative'][]>(
    `/initiatives/${initiativeId}/parents`
  );
  return data;
}

// Add parent to an initiative
export async function addInitiativeParent({
  initiativeId,
  parentId,
}: {
  initiativeId: number;
  parentId: number;
}) {
  const { data } = await defaultApi.post<components['schemas']['Initiative']>(
    `/initiatives/${initiativeId}/parents`,
    { parent_id: parentId }
  );
  return data;
}

// Remove parent from an initiative
export async function removeInitiativeParent({
  initiativeId,
  parentId,
}: {
  initiativeId: number;
  parentId: number;
}) {
  await defaultApi.delete(`/initiatives/${initiativeId}/parents/${parentId}`);
}

// Get children of an initiative
export async function getInitiativeChildren({ initiativeId }: { initiativeId: number }) {
  const { data } = await defaultApi.get<components['schemas']['Initiative'][]>(
    `/initiatives/${initiativeId}/children`
  );
  return data;
}

// Add child to an initiative
export async function addInitiativeChild({
  initiativeId,
  childId,
}: {
  initiativeId: number;
  childId: number;
}) {
  const { data } = await defaultApi.post<components['schemas']['Initiative']>(
    `/initiatives/${initiativeId}/children`,
    { child_id: childId }
  );
  return data;
}

// Remove child from an initiative
export async function removeInitiativeChild({
  initiativeId,
  childId,
}: {
  initiativeId: number;
  childId: number;
}) {
  await defaultApi.delete(`/initiatives/${initiativeId}/children/${childId}`);
}

// Get all ancestors (parents, grandparents, etc.) of an initiative
export async function getInitiativeAncestors({ initiativeId }: { initiativeId: number }) {
  const { data } = await defaultApi.get<components['schemas']['Initiative'][]>(
    `/initiatives/${initiativeId}/ancestors`
  );
  return data;
}

// Get all descendants (children, grandchildren, etc.) of an initiative
export async function getInitiativeDescendants({ initiativeId }: { initiativeId: number }) {
  const { data } = await defaultApi.get<components['schemas']['Initiative'][]>(
    `/initiatives/${initiativeId}/descendants`
  );
  return data;
}